import { Outlet } from "react-router-dom";
import Navigation from "./Navigation";
import { ButterflyBorder } from "./Template";
import './layout.css'


const Root = ({ }) => {
    return (
        <div id="page-layout-container">
            <header id="page-header" >
                <ButterflyBorder />
                <div id="page-header-content">
                    <img id="header-tnlogo" src="img/timpnatn_banner_logo_watermarked.png" />
                    <Navigation />
                </div>
            </header>
            <main className="main-layout">
                <Outlet />
            </main>
            <footer id="page-footer">
                <div>
                    <ul className="social-media-icons">
                        <li>
                            <a>
                                <img className="social-media-icons" src="img/social media icons/insta_icon.png"></img>
                            </a>
                        </li>
                        <li>
                            <a>
                                <img className="social-media-icons" src="img/social media icons/substack_icon.png"></img>
                            </a>
                        </li>
                        <li>
                            <a>
                                <img className="social-media-icons" src="img/social media icons/petreon_icon.png"></img>
                            </a>
                        </li>
                        <li>
                            <a>
                                <img className="social-media-icons" src="img/social media icons/facebook_icon.png"></img>
                            </a>
                        </li>
                        <li>
                            <a>
                                <img className="social-media-icons" src="img/social media icons/youtube_icon.png"></img>
                            </a>
                        </li>
                        <li>
                            <a>
                                <img className="social-media-icons" src="img/social media icons/email_icon.png"></img>
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <span id="copyright-msg">&copy; 2026 Timpanogos Nation</span>
                </div>
                <ButterflyBorder />
            </footer>
        </div>
    )
}

export default Root;